import * as React from 'react'

import {
    Stack,
    List,
    ListItemButton,
    ListItemIcon,
    ListSubheader,
    Box,
    Avatar,
    useMediaQuery
} from '@mui/material'
import { Logout } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { NossaSolucao } from './nossaSolucao'
import { NossosNumeros } from './nossosNumeros'
import Responsive from './Responsive'
import PartnerSection from './PartnerSection'
import { CarrouselParceiros } from './carrouselParceiros'
import { CarrouselClientes } from './carrouselClientes'
import { CarrouselClientesFalam } from './carrouselClientesFalam'
import { NossosProdutos } from './nossosProdutos'
import { Orcamento } from './orcamento'

interface INavBar {
    refSolucao?: any;
    titleSolucao?: any;
}



const Middle: React.FC<INavBar> = ({ refSolucao, titleSolucao }) => {
    const navigate = useNavigate();

    const matches = useMediaQuery('(max-width:800px)');
    return (
        <Box>
            <div title='nossol'>
                <NossaSolucao/>
            </div>
            <div title='num'>
                <NossosNumeros />
            </div>
            <div title='prod'>
                <NossosProdutos />
            </div>
            <div style={{
                backgroundColor: "white"
            }}>
                <div title='parc'>
                    <CarrouselParceiros />
                </div>
                <div title='cli'>
                    <CarrouselClientes />
                </div>
                
            </div>
            
            <div title='dep' style={{ display: "flex", justifyContent: "center" }} >
                <CarrouselClientesFalam />
            </div>
            <div title='orc'>
                <Orcamento />
            </div>
        </Box>
    );
}

export { Middle }